import React, { useState, useEffect } from "react";
import { firebase, authe } from "../Firebase/config";

import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  onAuthStateChanged,
  deleteUser,
} from "@firebase/auth";
import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  getCountFromServer,
} from "@firebase/firestore";
import axios from "axios";

import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
  redirect,
} from "react-router-dom";
import "./SignIn2.css";

import NavBar from "./Navbar";

const SignIn = ({ route }) => {

  const navigate = useNavigate();


  const [donotshow, setDonotshow] = useState();

  const sections = [
    { Name: "Active Passes", key: 1 },
    { Name: "Search By Name", key: 2 },
    { Name: "Search By Date", key: 3 },
  ];

  const [selectedclass, setSelectedclass] = useState();
  const [activename, setActivename] = useState("Active Passes");


  const [id2, setId] = useState();
  const [school2, setSchool] = useState();
  const [state2, setState] = useState();
  const [town2, setTown] = useState();
  const [role2, setRole] = useState();
  const [firstname2, setFirstname] = useState();
  const [lastname2, setLastname] = useState();
  const [phone2, setPhone2] = useState();
  const [teacheriscalled2, setTeacheriscalled] = useState();
  const [email2, setEmail] = useState();
  const [showspinner, setShowspinner] = useState();

  const [errorMessage, setErrorMessage] = useState("");
  const [emaillocal, setEmaillocal] = useState("");
  const [passwordlocal, setPasswordlocal] = useState("");

  const [previousEmails, setPreviousEmails] = useState([]);
  const [showEmailDropdown, setShowEmailDropdown] = useState(false);
  const [filteredEmails, setFilteredEmails] = useState([]);

  const [someoneisloggedin, setsomeoneisloggedin] = useState();
  const [passwordShown, setPasswordShown] = useState(true);
  const [oneway, setOneway] = useState();

  const [nothingfound, setNothingfound] = useState(false);

  const [personaldata, setPersonaldata] = useState();
  const [schoolid, setSchoolid] = useState();

  // Get route params - in web version this would be from URL or context
  const donewithquickpass = route?.params?.donewithquickpass;


  const newidforadmin = "/role/Admin/mainmenupage/id/" + id2;
  const newidforteacher = "/role/Teacher/mainmenu/id/" + id2;
  const newidforstudent1 = "/role/Student/Mainmenustudents/id/" + id2;
  const adminaddress = "/role/Admin/mainmenupage/id/" + id2;

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  async function getAllKeys() {
    // Web equivalent of clearing AsyncStorage
    localStorage.clear();

    // Get all keys in localStorage
    const keys = Object.keys(localStorage);
    checkhowmany(keys);
  }

  const checkhowmany = (keys) => {
    console.log(keys, "here are the keys");
    if (keys.length < 1) {
      console.log("There are NOT keys");
    } else {
      console.log("There are keys here");
    }
  };

  const auth = getAuth();

  const signoutfunction = () => {
    setShowspinner(false);
    getAllKeys();
    setEmaillocal("");
    setPasswordlocal("");
    setRole("");
    setId("");
    auth.signOut();
  };

  async function runcheckonemail() {
    console.log("Checking email:", emaillocal);
    if (
      emaillocal.length > 0 &&
      emaillocal.includes("@") &&
      emaillocal.includes(".")
    ) {
      // Prefix query — hides SignUp if any email in the system starts with what was typed
      const prefixQuery = query(
        collection(firebase, "users"),
        where("email", ">=", emaillocal),
        where("email", "<=", emaillocal + "\uf8ff"),
        limit(1)
      );
      const prefixSnap = await getDocs(prefixQuery);
      // Show SignUp only when no email in the system starts with the typed string
      setNothingfound(prefixSnap.empty);

      // Exact Student match for sign-in / sign-up navigation flow
      const f = query(
        collection(firebase, "users"),
        where("email", "==", emaillocal),
        where("role", "==", "Student")
      );

      const snapshot1 = await getCountFromServer(f);
      const totalCount = snapshot1.data().count;

      if (totalCount < 1) {
        console.log(emaillocal, "- no exact student match found.");

      } else if (totalCount === 1) {
        console.log("User found with this email:", emaillocal);

        const querySnapshot = await getDocs(f);

        querySnapshot.forEach((doc) => {

          if (doc.data().role == "Student") {
            console.log(doc.data().email, "This is the email");
            setPersonaldata(doc.data());
          }
          if (doc.data().googleclassroomid === doc.data().id) {

            console.log("User needs to sign up please", doc.data().id, doc.data().currentclass, "User needs to sign up please");

            navigate("/Signup2", { state: { userData: doc.data() } });

          } else {
            console.log("User has already signed up")
          }
        });

      } else {
        // Get all docs with .role == "Student" and .passwordactual == "'Sign Up' Needed"
        const querySnapshot = await getDocs(f);
        let studentSignUpNeededDocs = [];
        // Check if any doc does NOT have passwordactual === "'Sign Up' Needed"
        let docToKeep = null;
        querySnapshot.forEach((docSnap) => {
          if (
          docSnap.data().role === "Student" &&
          docSnap.data().googleclassroomid === docSnap.data().id
          ) {
            studentSignUpNeededDocs.push(docSnap);
          } else if (
             docSnap.data().role === "Student" &&
         docSnap.data().googleclassroomid != docSnap.data().id
          ) {
            docToKeep = docSnap;
          }
        });

        if (docToKeep) {
          // Delete all docs in studentSignUpNeededDocs
          for (const docToDelete of studentSignUpNeededDocs) {
            await deleteDoc(doc(firebase, "users", docToDelete.id));
          }
          // Do not navigate to Signup2
        } else {
          // Delete all but one doc in studentSignUpNeededDocs
          while (studentSignUpNeededDocs.length > 1) {
            const docToDelete = studentSignUpNeededDocs.pop();
            await deleteDoc(doc(firebase, "users", docToDelete.id));
          }
          // If the last remaining doc has passwordactual == "'Sign Up' Needed", navigate to Signup2
          if (
         studentSignUpNeededDocs[0].data().googleclassroomid === studentSignUpNeededDocs[0].data().id
          ) {
            navigate("/Signup2", { state: { userData: studentSignUpNeededDocs[0].data() } });
          }
        }


      }
    }
  }

  useEffect(() => {
    if (
      emaillocal.length > 0 &&
      emaillocal.includes("@") &&
      emaillocal.includes(".")
    ) {
      setNothingfound(false); // reset while the async check is in flight
      runcheckonemail();
    } else {
      setNothingfound(false); // hide SignUp when email format isn't complete
    }
  }, [emaillocal]);

  useEffect(() => {
    auth.signOut();
  }, []);

  useEffect(() => {
    setShowspinner(false);
  }, []);

  const authObj = getAuth();

  // Set up auth state listener
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(authObj, (user) => {
      if (user) {
        setsomeoneisloggedin(true);
        if (user.email === emaillocal) {
          console.log("active email", user.email);
          const uid = user.uid;
          setId(uid);
        }
      } else {
        setsomeoneisloggedin(false);
        setId("");
        setRole("");
      }
    });

    // Clean up the listener
    return () => unsubscribe();
  }, [emaillocal]);

  useEffect(() => {
    console.log("Here is id", id2);
    if (id2) {
      console.log(id2, "Was just registered for notifications");
      getinfo();
    }
  }, [id2]);

  useEffect(() => {
    if (role2) {
      sendaway();
    }
  }, [role2]);

  const getinfo = () => {
    const docRef = doc(firebase, "users", id2);
    const docData = getDoc(docRef).then((docSnap) => {
      console.log(docSnap.data(), "HERE IS THE DOC")
      if (docSnap.exists()) {
        if (docSnap.data().adminclass) {
          localStorage.setItem("adminclass", docSnap.data().adminclass);
          console.log("there was a adminclass");
        } else {
          console.log("there was not an adminclass");
        }
        if (docSnap.data().teacheriscalled) {
          localStorage.setItem(
            "teacheriscalled",
            docSnap.data().teacheriscalled
          );
          console.log("there was a teacheriscalled");
        } else {
          console.log("there was not a teachers is called");
        }

        if (docSnap.data().localfirstname) {
          localStorage.setItem("firstname", docSnap.data().localfirstname);
          console.log("there was a firstnaame", docSnap.data().localfirstname);
        } else {
          console.log("there was not a firstname is called");
        }

        if (docSnap.data().locallastname) {
          localStorage.setItem("lastname", docSnap.data().locallastname);
          console.log("there was a lastname", docSnap.data().locallastname);
        } else {
          console.log("there was not a lastname is called");
        }
        if (docSnap.data().role) {
          localStorage.setItem("role", docSnap.data().role);
          console.log("there was a role", docSnap.data().role);
        } else {
          console.log("there was not a role is called");
        }
        if (docSnap.data().id) {
          localStorage.setItem("id", docSnap.data().id);
          console.log("there was an id", docSnap.data().id);
        } else {
          console.log("there was not an id called");
        }
        if (docSnap.data().school) {
          localStorage.setItem("school", docSnap.data().school);
          console.log("there was an school", docSnap.data().school);
        } else {
          console.log("there was not a school called");
        }
        if (docSnap.data().town) {
          localStorage.setItem("town", docSnap.data().town);
          console.log("there was an town", docSnap.data().town);
        } else {
          console.log("there was not a town called");
        }
        if (docSnap.data().state) {
          localStorage.setItem("state", docSnap.data().state);
          console.log("there was an state", docSnap.data().state);
        } else {
          console.log("there was not a state called", docSnap.data().state);
        }
        if (docSnap.data().email) {
          localStorage.setItem("email", docSnap.data().email);
          console.log("there was an email", docSnap.data().email);
          setEmail(docSnap.data().email);
        } else {
          console.log("there was not a email called", docSnap.data().email);
        }

        if (docSnap.data().phonenumber) {
          localStorage.setItem("phonenumber", docSnap.data().phonenumber);
          setPhone2(docSnap.data().phonenumber);
          console.log("there was a phone number", docSnap.data().phonenumber);
        } else {
          console.log("there was not a phone number called");
          localStorage.setItem("phonenumber", "None Listed");
          setPhone2("None Listed");
        }

        setEmail(docSnap.data().email);
        setSchool(docSnap.data().school);
        setTown(docSnap.data().town);
        setState(docSnap.data().state);
        setFirstname(docSnap.data().localfirstname);
        setLastname(docSnap.data().locallastname);
        setPhone2(docSnap.data().phonenumber);

        setTeacheriscalled(docSnap.data().teacheriscalled);
        setEmaillocal("");
        setPasswordlocal("");
        setRole(docSnap.data().role);
      } else {
        alert(
          'The user "Document" cannot be found. The user needs to recreate the account.'
        );
      }
    });
  };

  const sendaway = () => {
    if (role2 === "Student") {
      setShowspinner(false);

      console.log("this is the id in signup.", id2, school2, town2, state2, role2, firstname2, lastname2, email2, phone2);


      navigate(newidforstudent1, { state: { personaldata } });

    }
    if (role2 === "Teacher") {
      setShowspinner(false);

      navigate(newidforteacher, { state: { id2, school2, town2, state2, role2, teacheriscalled2, email2 } });

    }
    if (role2 === "Admin") {
      setShowspinner(false);

      navigate(adminaddress, { state: { id2, school2, state2, town2, schoolid } });

    } else {
      console.log("This is the role", role2, "Slow your role");
    }
  };

  const login = async () => {
    setShowspinner(true);
    console.log("Login attempt with:", emaillocal, passwordlocal);

    signInWithEmailAndPassword(auth, emaillocal, passwordlocal)
      .then(async (userCredential) => {
        console.log("Firebase login successful");
        saveEmailToLocalStorage(emaillocal);

        // Fetch user document from Firestore
        const user = userCredential.user;
        const docRef = doc(firebase, "users", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {


          const userData = docSnap.data();
          const role = userData.role;
          console.log("User role after login:", role);

          // Navigate based on role
          if (role === "Student") {
            navigate(`/role/Student/Mainmenustudents/id/${user.uid}`, { state: { personaldata: userData } });
          } else if (role === "Teacher") {
            navigate(`/role/Teacher/mainmenu/id/${user.uid}`, { state: { id2: user.uid, school2: userData.school, town2: userData.town, state2: userData.state, ...userData } });
          } else if (role === "Admin") {
            navigate(`/role/Admin/mainmenupage/id/${user.uid}`, { state: { id2: user.uid, school2: userData.school, town2: userData.town, state2: userData.state, schoolid: userData.schoolid, ...userData } });
          } else {
            alert("Unknown role. Setting role to 'Student' and continuing.");
            try {
              await updateDoc(docRef, { 
                role: "Student",
                school: userData.school || "Unknown School",
                town: userData.town || "Unknown Town",
                state: userData.state || "Unknown State"
              
              });
              console.log("Role updated to 'Student' in Firestore.");
              // Optionally update userData in memory too
              userData.role = "Student";
              navigate(`/role/Student/Mainmenustudents/id/${user.uid}`, { state: { personaldata: userData } });
            } catch (err) {
              alert("Failed to update role in Firestore. Please contact support.");
              console.error("Error updating role in Firestore:", err);
            }
          }
        } else {
          alert("User document not found. Please contact support.");
        }
      })
      .catch(async (error) => {
        setShowspinner(false);
        const errorMessage = error.message;
        console.log("Firebase login failed:", errorMessage);

        // Check Firestore for a users document with this email and password
        const q = query(
          collection(firebase, "users"),
          where("email", "==", emaillocal),
          where("password", "==", passwordlocal)
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          // Log all found documents
          querySnapshot.docs.forEach((docSnap, idx) => {
            console.log(`SignIn2: Found Firestore user document #${idx + 1}:`, docSnap.data());
          });
          // Use the first document as before
          const docData = querySnapshot.docs[0].data();
          navigate("/Signup2", { state: { userData: docData } });
        } else {
          alert("Login Failed: Check your email and password and try again.");
          console.log("No matching Firestore user document found.");
        }
      });
  };

  const go = () => {
    navigate("/role/Student/Mainmenustudents", {
      state: {
        school2,
        state2,
        town2,
        role2,
        firstname2,
        lastname2,
        id2,
        email2,
        phone2,
      },
    });
  };

  useEffect(() => {
    const loadPreviousEmails = () => {
      try {
        const storedEmails = localStorage.getItem('previousEmails');
        if (storedEmails) {
          const emails = JSON.parse(storedEmails);
          setPreviousEmails(emails);

          // Auto-fill the most recent email
          if (emails.length > 0) {
            setEmaillocal(emails[0]);
          }
        }
      } catch (error) {
        console.error('Error loading previous emails:', error);
      }
    };

    loadPreviousEmails();
  }, []);

  useEffect(() => {
    if (emaillocal && previousEmails.length > 0) {
      const filtered = previousEmails.filter(
        email => email.toLowerCase().includes(emaillocal.toLowerCase())
      );
      setFilteredEmails(filtered);
    } else {
      setFilteredEmails([]);
    }
  }, [emaillocal, previousEmails]);

  const saveEmailToLocalStorage = (email) => {
    try {
      let emails = [];
      const storedEmails = localStorage.getItem('previousEmails');

      if (storedEmails) {
        emails = JSON.parse(storedEmails);
      }

      // Remove the email if it exists already
      emails = emails.filter(e => e !== email);

      // Add the email to the beginning of the array (most recent)
      emails.unshift(email);

      // Limit the number of stored emails (keep most recent 5)
      if (emails.length > 5) {
        emails = emails.slice(0, 5);
      }

      localStorage.setItem('previousEmails', JSON.stringify(emails));
      setPreviousEmails(emails);
    } catch (error) {
      console.error('Error saving email to localStorage:', error);
    }
  };

  const handleEmailChange = (e) => {
    setEmaillocal(e.target.value);
    if (previousEmails.length > 0) {
      setShowEmailDropdown(true);
    }
  };

  // Select email from dropdown
  const selectEmail = (email) => {
    setEmaillocal(email);
    setShowEmailDropdown(false);
  };

  return (
    <div className="App22">

      <NavBar
        donotshow={donotshow}
        role={role2}
        sections={sections}
        setSelectedclass={setSelectedclass}
        activename={activename}
      />
      <div className="container1" style={{ height: "50px" }}>
        {passwordShown ? (
          <div className="error" onClick={() => togglePasswordVisiblity()}>
            Hide<br />Password
          </div>
        ) : (
          <div className="error" onClick={() => togglePasswordVisiblity()}>
            Show<br />Password
          </div>
        )}
      </div>



      <div className="container2">
        <div className="container">
          <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
            <input
              className="Newrow"
              placeholder="Email"
              value={emaillocal.toLowerCase()}
              onChange={handleEmailChange}
              onFocus={() => previousEmails.length > 0 && setShowEmailDropdown(true)}
              onBlur={() => setTimeout(() => setShowEmailDropdown(false), 200)}
            // style={{ width: '100%', maxWidth: '300px' }}
            />
            {showEmailDropdown && filteredEmails.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  width: '100%',
                  maxWidth: '300px',
                  maxHeight: '150px',
                  overflowY: 'auto',
                  backgroundColor: 'white',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  zIndex: 10,
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  top: '100%'
                }}
              >
                {filteredEmails.map((email, index) => (
                  <div
                    key={index}
                    onClick={() => selectEmail(email)}
                    style={{
                      textAlign: 'center',
                      color: '#333',
                      padding: '8px 12px',
                      cursor: 'pointer',
                      borderBottom: index < filteredEmails.length - 1 ? '1px solid #eee' : 'none',
                      hover: { backgroundColor: '#f5f5f5' }
                    }}
                    onMouseDown={(e) => e.preventDefault()} // Prevent blur from closing dropdown
                  >
                    {email}
                  </div>
                ))}
              </div>
            )}
          </div>
          <input
            className="Newrow"
            placeholder="Password"
            autoCapitalize="none"
            type={passwordShown ? "text" : "password"}
            value={passwordlocal}
            onChange={(e) => setPasswordlocal(e.target.value)}
          />
        </div>
      </div>

      <div className="section3">
        <div>
          {showspinner && <div className="spinner"></div>}
        </div>
        <div className="scroll-container">
          {someoneisloggedin === false &&
            emaillocal !== "" &&
            passwordlocal !== "" &&
            showspinner !== true ? (
            <div className="touchable">
              <div className="paragraph22" onClick={login}>
                Login
              </div>
            </div>
          ) : someoneisloggedin === false &&
            emaillocal !== "" &&
            passwordlocal !== "" &&
            showspinner !== true ? (
            <div className="paragraph22A">Processing</div>
          ) : someoneisloggedin === true ? (
            <div className="touchable">
              <div className="paragraph222" style={{ color: "#f7b267" }}>
                You are logged in
              </div>
            </div>
          ) : (
            <div className="touchable">
              <div className="paragraph222" style={{ color: "#f7b267" }}>
                {" "}
              </div>
            </div>
          )}

          {nothingfound === true ? (
            <>
              <div className="paragraph2">___________________ </div>
              <div className="paragraph2">Don't have an account? </div>
              <div className="touchable">
                <div
                  className="paragraph22"
                  onClick={() => navigate("/Signup2")}
                >
                  SignUp
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="paragraph22b">___________________ </div>
              <div className="paragraph22b">Don't have an account? </div>
              <div className="touchable">
                <div className="paragraph22b">SignUp</div>
              </div>
            </>
          )}

          {someoneisloggedin === true && (
            <>
              <div className="paragraph2">___________________ </div>
              <div className="touchable">
                <div className="paragraph22" onClick={() => signoutfunction()}>
                  Sign Out
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignIn;
